/**
 * @providesModule RewardCalendarController
 * This is the main controller for Reward Calendar
 */

const RewardCalendarController = {};

export default RewardCalendarController;
